export default __webpack_public_path__ + "static/media/giraffe.7eb466b2.png";